import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { Asset } from "./types/asset.type";

/* Request Types */
export interface CreateAssetReq {
  name: string;
  filename: string;
  pipelineKey: string;
}

export interface UpdateAssetReq {
  projectId: string;
  studyId: string;
  assetId: string;
  values: UpdateAssetValues;
}

export interface UpdateAssetValues {
  name: string;
  filename: string;
}

export interface DeleteAssetReq {
  projectId: string;
  studyId: string;
  assetId: string;
}

/* Response Types */
export interface GetAssetsResp {
  assets: Array<Asset>;
}

export interface CreateAssetResp {
  asset: Asset;
}

export interface UpdateAssetResp {
  asset: Asset;
}

export interface DeleteAssetResp {
  id: string;
}

/*
 * getAssets endpoint
 *
 * Returns all assets for a given study with their relevant metadata.
 */
export const getAssets = async (projectId: string, studyId: string) => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/assets`);
  return resp.data as GetAssetsResp;
};

/*
 * createAsset endpoint
 *
 * Adds a new asset to a given study.
 */
export const createAsset = async (projectId: string, studyId: string, values: CreateAssetReq) => {
  const resp = await api.post(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/assets`, values);
  return resp.data as CreateAssetResp;
};

/*
 * updateAsset endpoint
 *
 * Updates an existing asset.
 */
export const updateAsset = async ({ projectId, studyId, assetId, values }: UpdateAssetReq) => {
  const payload: UpdateAssetValues = {
    name: values.name,
    filename: values.filename,
  };

  const resp = await api.put(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/assets/${assetId}`, payload);
  return resp.data as UpdateAssetResp;
};

/*
 * deleteAsset endpoint
 *
 * Deletes an existing asset.
 */
export const deleteAsset = async ({ projectId, studyId, assetId }: DeleteAssetReq) => {
  const resp = await api.delete(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/assets/${assetId}`);
  return resp.data as DeleteAssetResp;
};
